/*
 * Creative Cycles Workshop form confirmations.
 *
 * Shopify returns a posted contact form to the page in return_to. The call back and message forms
 * set ?sent=callback or ?sent=message, and this swaps the matching form for its confirmation in
 * place. On Contact it also selects the tab the confirmation belongs to.
 */
(() => {
  const params = new URLSearchParams(location.search);
  const about = params.get('about');
  if (about) {
    // Arrived from "Contact us about this bike": open Send a message with the bike named.
    const prefill = () => {
      const tab = document.querySelector('#ccw-tab-message');
      const body = document.querySelector('#ccw-contact-body');
      if (tab) tab.checked = true;
      if (body && !body.value) body.value = 'About: ' + about.slice(0, 160) + '\n\n';
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prefill);
    else prefill();
  }
  // A failed message re-renders with Call me back checked; open the message tab so its error shows.
  const messageError = () => {
    if (document.querySelector('[data-message-form] .ccw-form__notice--error')) {
      const tab = document.querySelector('#ccw-tab-message');
      if (tab) tab.checked = true;
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', messageError);
  else messageError();
  const sent = params.get('sent');
  if (sent !== 'callback' && sent !== 'message') return;

  const show = (form, done) => {
    if (!form || !done) return;
    form.hidden = true;
    done.hidden = false;
    done.focus({ preventScroll: true });
  };

  const run = () => {
    if (sent === 'callback') {
      document.querySelectorAll('[data-callback]').forEach((box) => {
        show(box.querySelector('[data-callback-form]'), box.querySelector('[data-callback-done]'));
      });
      return;
    }
    const tab = document.querySelector('#ccw-tab-message');
    if (tab) tab.checked = true;
    show(document.querySelector('[data-message-form]'), document.querySelector('[data-message-done]'));
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
